export const IconGrayPhoneMobileNumber20: {
  name: 'icon_gray_phone_mobile_number_20-4f6d1a424ac2'
} = {
  name: 'icon_gray_phone_mobile_number_20-4f6d1a424ac2'
}
